import { ErrorHandler } from './errorHandler';
import axios, { AxiosInstance } from 'axios';
import { Service } from 'vue-di-container';

@Service()
export default class HttpService {
  public httpInstance: AxiosInstance;
  constructor() {
    const config = {
      baseURL: process.env.BASE_URL,
    };
    this.httpInstance = axios.create(config);

    this.httpInstance.interceptors.request.use(
      (request) => request,
      (error) => ErrorHandler.errorResponseHandler(error),
    );

    // Add a response interceptor
    this.httpInstance.interceptors.response.use(
      (response) => response,
      (error) => ErrorHandler.errorResponseHandler(error),
    );
  }
}
